// Intentionally import-free so this file can be called from publicEarlyRequester.ts
// before any module bundling side-effects run.
// §18 adapter: single local cast covers all runtime-injected globals in this file.

const win = window;
const legacyNav = window.navigator;
function getManualLang() {
  var _win$I18N_MANUAL_LANG;
  return (_win$I18N_MANUAL_LANG = win.I18N_MANUAL_LANG) !== null && _win$I18N_MANUAL_LANG !== void 0 ? _win$I18N_MANUAL_LANG : '';
}
function getLegacyNavLang(key) {
  var _legacyNav$key;
  return (_legacyNav$key = legacyNav[key]) !== null && _legacyNav$key !== void 0 ? _legacyNav$key : '';
}
function getNavigatorLanguage() {
  const nav = window.navigator;
  if (nav.languages && nav.languages.length) {
    return nav.languages[0];
  }
  return nav.language || getLegacyNavLang('userLanguage') || getLegacyNavLang('browserLanguage') || getLegacyNavLang('systemLanguage') || '';
}

// Inline localStorage read so this file stays import-free.
function getDebugBrowserLocale() {
  try {
    return localStorage.getItem('PUBLIC_DEBUG_BROWSER_LOCALE') || '';
  } catch (_unused) {
    return '';
  }
}

/**
 * Returns the i18n preferred language string (e.g. 'en-US', 'de').
 *
 * Reads I18N_MANUAL_LANG (set by per-locale HTML wrappers or debug i18n
 * override), then falls back to navigator language.
 *
 * For the `browserLocale` RPC param, use {@link getBrowserLocale} instead
 * — it skips I18N_MANUAL_LANG so the i18n debug override doesn't leak
 * into RPC calls.
 *
 * This is intentionally kept import-free so it can be called from
 * publicEarlyRequester.ts before any module bundling side-effects run.
 */
export const getPreferredLanguage = () => {
  const manualLang = getManualLang();
  if (manualLang) {
    return manualLang;
  }
  return getNavigatorLanguage();
};

/**
 * Returns the browser locale for RPC `browserLocale` params, always lowercased.
 *
 * Lowercase for consistency: I18N_MANUAL_LANG (set by HubSpot per-locale HTML
 * wrappers) is lowercase, so normalising everything to lowercase ensures the
 * early-request cache key always matches the DFC query key regardless of source.
 *
 * Intentionally skips I18N_MANUAL_LANG so the i18n debug override
 * doesn't bleed into RPC calls.
 */
export const getBrowserLocale = () => {
  const debugLocale = getDebugBrowserLocale();
  if (debugLocale) {
    return debugLocale.toLowerCase();
  }
  return (getNavigatorLanguage() || 'en-us').toLowerCase();
};